<template>
  <div class="participant-app-notification" id="add-participant-notification">
    <div class="mb-10 mt-30 font-weight-bold">Participant notifications</div>
    <div v-if="isNotificationAddEdit">
      <div v-for="(items, index) in options.appNotification" :key="items">
        <ParticipantAppNotificationsComponent
          @updateReminder="updateReminder"
          :options="{
            advanceScheduleDays: options.telehealthVisit.scheduler.advanceScheduleDays ? options.telehealthVisit.scheduler.advanceScheduleDays : 0,
            completionWindow: options.telehealthVisit.scheduler.completionWindow,
            telehealthVisit: options.telehealthVisit,
            remindersList: options.remindersList,
            appNotification: items,
            actualNotificationList: options.appNotification,
            isDataExist: options.isDataExist,
            indexValue: index
          }"
          :studyData="studyData"
        >
        </ParticipantAppNotificationsComponent>
      </div>
    </div>
    <div class="pt-15" v-if="isPanelDisplay">
      <button class="btn btn-outline-primary font-weight-bold font-size-12 add_a_notification_btn" @click="addNewNotification()">
        Add a notification
      </button>
    </div>
  </div>
</template>

<script>
import ParticipantAppNotificationsComponent from "./participant-app-notifications.vue";
export default {
  name: "edit-notification",
  components: {
    ParticipantAppNotificationsComponent
  },
  data() {
    return {
      completionWindow: this.options.completionWindow,
      isPanelDisplay: this.options.appNotification.length != 2,
      isNotificationAddEdit: this.options.appNotification.length > 0,
      remindersListTeleHealth: [],
      actualNotificationList: this.options.appNotification
    };
  },
  props: ["options", "studyData"],
  mounted() {},
  watch: {
    options(newValue) {
      this.remindersList = [];
      this.remindersList = newValue.remindersList;
      this.completionWindow = newValue.completionWindow;
      this.advanceScheduleDays = newValue.advanceScheduleDays;
      this.actualNotificationList = newValue.actualNotificationList;
      newValue.completionWindow = Number(newValue.completionWindow) === 0 ? 1 : newValue.completionWindow;
      if (newValue.completionWindow && this.remindersList) {
        this.remindersList.length = Number(newValue.completionWindow) - 1;
      }
    }
  },
  methods: {
    addNewNotification() {
      if (this.options.appNotification.length == 2) {
        this.isNotificationAddEdit = true;
        this.isPanelDisplay = false;
        this.$forceUpdate();
        return;
      }
      this.options.appNotification.push({
        eventType: 0,
        time: {
          hh: "",
          mm: "",
          A: ""
        },
        message: "",
        day: "default",
        telehealthReminders: [],
        occurranceList: [{ text: null, value: null, emailToggle: false, smsToggle: false }]
      });
      this.isNotificationAddEdit = true;
      if (this.options.appNotification.length == 2) {
        this.isPanelDisplay = false;
      }
      this.$forceUpdate();
      this.$nextTick(() => {
        this.smoothLandingOnScreen();
      });
    },
    smoothLandingOnScreen() {
      const element = document.getElementById("add-participant-notification");
      element.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth"
      });
    },
    updateReminder(reminder) {
      if (this.options.appNotification.length != 2) {
        this.isPanelDisplay = true;
        this.$forceUpdate();
      }
      this.$emit("updateReminder", {
        notificationList: reminder.notificationList,
        eventType: reminder.eventType,
        index: reminder.index,
        action: reminder.action
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.add_a_notification_btn {
  background-color: #4c8ce4;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal !important;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 50px;
  padding: 1px 14px 0px 0px;
  height: auto !important;
  line-height: 24px !important;
}
.add_a_notification_btn:before {
  content: "\f055";
  font-family: "FontAwesome";
  color: white;
  font-size: 26px;
  float: left;
  padding: 0px 6px 0px 2px;
}
.opacity-change {
  opacity: 0.5;
}
</style>
